module.exports = __webpack_public_path__ + "static/media/logo.81f5edb3.png";